import Vue from 'vue'
import FddLoading from './Loading.vue'
let instance = null //唯一实例
const Loading = Vue.extend(FddLoading)
Loading.prototype.inProcess = false
// Loading.prototype.remove  = function(){
//     setTimeout(()=>{
//         if(this.$el && this.$el.parentNode){
//             this.$el.parentNode.removeChild(this.$el);
//         }
//         this.inProcess = false;
//         this.$destroy();
//         instance = null;
//     },500);
// }

Loading.prototype.stop = function(speed, time) {
  speed = speed || 1
  time = time || 10
  this.inProcess = false
  this.run(2, 10)
}
Loading.prototype.start = function() {
  this.inProcess = true
  this.run(0.2, 300)
}
Loading.prototype.isInProcess = function() {
  return this.inProcess
}
const createLoading = () => {
  if (Vue.isServer) return false
  if (!instance) {
    instance = new Loading()
    document.body.appendChild(instance.$mount().$el)
  }

  return instance
}
export default createLoading
